<template>
    <v-form name="set-refuse-form">
        <div class="grid"
             style="margin-top:5px">
            <FormSelect fieldName="dctrefuse_id"
                        label="Refuse reason"
                        size="12"
                        validation="required"
                        :showClear="true"
                        :options="select?.dct_lead_refuses"
                        v-model:field="dctReasonId" />

            <FormInputText fieldName="refuse_reason"
                           label="Detailed reason"
                           size="12"
                           v-model:field="refuse_reason" />
        </div>

        <div class="grid"
             style="margin-top:20px">
            <Button @click.stop="setRefuse"
                    :class="buttonClass('green')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-circle-xmark"></i><span>{{ __('Refuse') }}</span></template>
            </Button>

            <Button @click="cancel"
                    :class="buttonClass('gray')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-trash-can"></i><span>{{ __('Cancel') }}</span></template>
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import Button from 'primevue/button';
import FormInputText from '@crud/FormInputText.vue'
import FormSelect from '@crud/FormSelect.vue'
import { __, getFromRoute, screenMessage, buttonClass } from '@pages/Helper/utils.js'
import { validation, prepareSelect } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------
const props = defineProps({
    leadData: Object,
    formProps: Object,
})

const isSetRefuseModalOpen = defineModel('isSetRefuseModalOpen')
const refuse_reason = ref('')
const options = ["dct_lead_refuses"];
const select = ref(null);
const dctReasonId = ref(null);

// -----------------------------------------------------

onBeforeMount(async () => {
    select.value = await prepareSelect(options)
})

// -----------------------------------------------------

const cancel = () => {
    isSetRefuseModalOpen.value = false
}
// -----------------------------------------------------

const setRefuse = async () => {
    const formData = {
        'id': props.leadData.id,
        'dctrefuse_id': dctReasonId.value,
        'status_symbol': 'SYM_REFUSED',
        'refuse_reason': refuse_reason.value
    }

    if (validation(formData, 'set-refuse-form')) {
        const response = await getFromRoute('lead-status-set', formData, 'post');
        screenMessage({ ...response })

        isSetRefuseModalOpen.value = false
        props.formProps.closeModal()
        props.formProps.getLazyData()
    }
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
